import { OrganizationResponse } from "../contracts/OrganizationResponse";
import { OrganizationKind } from "../enums/OrganizationKind";
import { Organization, OrganizationVocabulary } from "../models/Organization";

/**
 * Maps organization responses from the API to frontend models.
 */
export class OrganizationResponseMapper {
  /**
   * Converts an OrganizationResponse to an Organization model. A response
   * from an older API without kind / language / vocabulary falls back to the
   * Default kind, English and an empty map (the Default preset applies).
   */
  toOrganization = (resp: OrganizationResponse): Organization => {
    return {
      id: resp.id,
      name: resp.name,
      ownerId: resp.ownerId,
      currency: resp.currency,
      dateCreated: resp.dateCreated,
      dateModified: resp.dateModified,
      kind: resp.kind ?? OrganizationKind.Default,
      languageCode: resp.languageCode ?? "en",
      // An older API without the field never asks the first-run question.
      kindChosenAt: resp.kindChosenAt === undefined ? resp.dateCreated : resp.kindChosenAt,
      vocabulary: this.toVocabulary(resp.vocabulary),
    };
  };

  private toVocabulary = (
    vocabulary: OrganizationResponse["vocabulary"] | null | undefined
  ): OrganizationVocabulary => {
    const result: OrganizationVocabulary = {};
    for (const [locale, slots] of Object.entries(vocabulary ?? {})) {
      result[locale] = {};
      for (const [slot, term] of Object.entries(slots ?? {})) {
        result[locale][slot] = {
          one: term.one,
          other: term.other,
          isOverridden: term.isOverridden,
        };
      }
    }
    return result;
  };
}
